import { useIntl } from "react-intl";

import { messages } from "./messages.generated";

export interface ScanCodeMessages {
    label: string;
    open: string;
    previewAlt: string;
    imageAlt: string;
    download: string;
    downloadError: string;
    loadError: string;
    retry: string;
}

export const useScanCodeMessages = (): ScanCodeMessages => {
    const intl = useIntl();
    const label = intl.formatMessage(messages.qrCodeLabel);

    return {
        label,
        open: intl.formatMessage(messages.openScanCode, { label }),
        previewAlt: intl.formatMessage(messages.scanCodePreviewAlt, { label }),
        imageAlt: intl.formatMessage(messages.scanCodeImageAlt, { label }),
        download: intl.formatMessage(messages.downloadScanCode, { label }),
        downloadError: intl.formatMessage(messages.downloadScanCodeError),
        loadError: intl.formatMessage(messages.scanCodeLoadError),
        retry: intl.formatMessage(messages.retryScanCode),
    };
};
